










































































































































import Component, { mixins } from 'vue-class-component';
import { loadView, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IOrganizations, IPaginate, IUssdCallback } from '@/types/types';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import qs from 'qs';

const ussdModule = namespace('ussdAdmin');
const organizationModule = namespace('organizations');

@Component({
  name: 'UssdServiceCodes',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    UssdCallbackDialog: loadView('pages/ussd/dialogs/UssdCallbackDialog'),
  },
  filters: { timestamp },
})
export default class UssdServiceCodes extends mixins(WidgetMixins, DialogMixins) {
  @ussdModule.Getter('getCallbacks') callbacks!: IUssdCallback[];
  @ussdModule.Getter('getCallbacksPagination') pagination!: IPaginate;
  @organizationModule.Getter('getAllOrganizations') organizations!: IOrganizations[];

  options: any = {};
  query: string = '';
  search: string = '';
  status: string = 'ALL';
  editing: IUssdCallback | null = null;

  headers: Array<{ text: string; value: string; sortable?: boolean }> = [
    { text: 'Service Code', value: 'serviceCode' },
    { text: 'Short Code', value: 'shortCode' },
    { text: 'Callback URL', value: 'callbackUrl' },
    { text: 'Version', value: 'ussdVersion' },
    { text: 'Status', value: 'status' },
    { text: 'Updated', value: 'updatedAt' },
    { text: '', value: 'actions', sortable: false },
  ];

  openDialog(callback: IUssdCallback | null = null): void {
    this.editing = callback;
    this.open('add');
  }

  handleSave(payload: { id?: string; body: any }): void {
    if (payload.id) {
      this.$store.dispatch('ussdAdmin/updateCallback', { ...payload, query: this.query });
    } else {
      this.$store.dispatch('ussdAdmin/createCallback', { body: payload.body, query: this.query });
    }
  }

  toggleStatus(item: IUssdCallback): void {
    this.$store.dispatch('ussdAdmin/updateCallbackStatus', {
      id: item._id,
      status: item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
      query: this.query,
    });
  }

  fetchCallbacks(): void {
    this.$store.dispatch('ussdAdmin/fetchCallbacks', this.query);
  }

  buildQuery(page: number = 1, limit: number = 50): string {
    return qs.stringify(
      {
        page,
        limit,
        ...(this.status !== 'ALL' && { status: this.status }),
        ...(this.search && { serviceCode: this.search }),
      },
      { skipNulls: true, addQueryPrefix: true },
    );
  }

  @Watch('status')
  @Watch('search')
  onFilterChange(): void {
    this.query = this.buildQuery();
    this.fetchCallbacks();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const query = this.buildQuery(paginate.page, paginate.itemsPerPage);
    if (query === this.query) return;
    this.query = query;
    this.fetchCallbacks();
  }

  created(): void {
    this.$store.dispatch('organizations/list', false);
    this.query = this.buildQuery();
    this.fetchCallbacks();
  }
}
